import { render } from "./emailDialog.vue?vue&type=template&id=368b97e2&scoped=true"
import script from "./emailDialog.vue?vue&type=script&lang=js"
export * from "./emailDialog.vue?vue&type=script&lang=js"

import "./emailDialog.vue?vue&type=style&index=0&id=368b97e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-368b97e2"]])

export default __exports__